import React, { MouseEvent, useState } from "react";
import { domainsProps } from "../../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import { ADD_NEW_SEGMMENT_END_POINT } from "../../../../../config/config";
import { AxiosError } from "axios";

const AddSegment : React.FC<domainsProps> = ({id, domain_name}) =>{

    const [segmentName, setSegmentName] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [submitStat, setSubmitStat] = useState({
        submited : false,
        msg : ''
    });

    function saveSegmentName (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(segmentName === '') return setSubmitStat({
            ...submitStat,
            msg : 'Please insert segment name.'
        })
        setLoading(true);
        setTimeout(async()=>{
            try{
                await api.post(ADD_NEW_SEGMMENT_END_POINT, {
                    id : id,
                    segment_name : segmentName
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setLoading(false);
                setSubmitStat({
                    ...submitStat,
                    submited : true,
                    msg : 'New segment added!'
                })
                setSegmentName('')
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setSubmitStat({
                        ...submitStat,
                        submited : false,
                        msg : 'Unauthorized access!'
                    })
                }else{
                    setSubmitStat({
                        ...submitStat,
                        submited : false,
                        msg : 'An error occured!'
                    })
                }
                setLoading(false);
            }
        },500);
    }

    return (
        <div>
            <div>
                Add new Segment for {domain_name}
            </div>
            <div>
                <div className={submitStat.submited ? "text-green-600" :"text-red-500"}>
                    {submitStat.msg}
                </div>
                <form>
                    <div className="input-container flex flex-col">
                        <label htmlFor="#segment_name">Segment Name:</label>
                        <input type="text" name="segment_name" id="segment_name" value={segmentName} onChange={(e)=>setSegmentName(e.target.value)} className="text-box" />
                    </div>
                    <div className="input-container">
                        {loading ? (
                            <button type="button" disabled className='button button-disabled'>
                                <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                            </button>
                        ) : (
                            <button type="button" onClick={saveSegmentName} className="button button-vcc-primary text-md">
                                Save Segment
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddSegment;